// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2.gh-productsAndServicesHeader{font-size:1.5rem;margin-bottom:1rem}", ""]);
// Exports
module.exports = exports;
